module.exports = __webpack_public_path__ + "media/images/optimizer_view-1287eca448544f3e4e92fd19ffeeead2.png";